<div
  class="kpi-number"
  [matTooltip]="
    hasExclusion
      ? ('FIXED_VALUE_BECAUSE_EXCLUSION' | transloco)
      : historyHint
        ? (historyHint.key | transloco: historyHint.params)
        : ''
  "
>
  <span>{{ value | formatNumber: format }}{{ unit }}</span>
  @if (hasExclusion) {
    <span>*</span>
  }
  @if (historyHint) {
    <mat-icon class="history-icon">query_stats</mat-icon>
  }
</div>
